var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 35,
    viewBox: "0 0 25 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 16.3333C11.0616 16.3333 10.0018 15.8943 9.22039 15.1129C8.43899 14.3315 8 13.2717 8 12.1667C8 11.0616 8.43899 10.0018 9.22039 9.22039C10.0018 8.43899 11.0616 8 12.1667 8C13.2717 8 14.3315 8.43899 15.1129 9.22039C15.8943 10.0018 16.3333 11.0616 16.3333 12.1667C16.3333 12.7138 16.2256 13.2557 16.0162 13.7612C15.8068 14.2667 15.4999 14.726 15.1129 15.1129C14.726 15.4999 14.2667 15.8068 13.7612 16.0162C13.2557 16.2256 12.7138 16.3333 12.1667 16.3333ZM12.1667 0.5C9.07247 0.5 6.10501 1.72916 3.91709 3.91709C1.72916 6.10501 0.5 9.07247 0.5 12.1667C0.5 20.9167 12.1667 33.8333 12.1667 33.8333C12.1667 33.8333 23.8333 20.9167 23.8333 12.1667C23.8333 9.07247 22.6042 6.10501 20.4162 3.91709C18.2283 1.72916 15.2609 0.5 12.1667 0.5Z",
    fill: "#B2BFCC",
    stroke: "#29333D",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinOutline);
export default __webpack_public_path__ + "static/media/PinOutline.7b14758c83b6bea4de76c17dabf42ec8.svg";
export { ForwardRef as ReactComponent };